import { Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'src/Member/components/common/skeleton';

const MessageDetailSelecton = () => {
  return (
    <>
      <Card className="p-3">
        <Row className="">
          <Col>
            <Skeleton width="100%" height={40} count={1} className="mb-3" />
          </Col>
        </Row>
        <Row className="">
          <Col>
            <Skeleton width="100%" height={335} count={1} />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default MessageDetailSelecton;
